import Vue from 'vue'
import App from './app'
import VcImagePlaceholder from './components/vc-image-placeholder'
import Vuecidity from 'vuecidity'
import 'vuecidity/dist/lib/vuecidity.min.css'

Vue.config.productionTip = false

Vue.use(Vuecidity)
Vue.use(VcImagePlaceholder)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/docs.js